import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { BaseNavStateComponent } from './components/base-component/base-nave-state.component'

@NgModule({
  declarations: [BaseNavStateComponent],
  imports: [CommonModule]
})
export class NavigationStateModule {}
